module.exports = __webpack_public_path__ + "components/country-flag/static/tr-acbe16a3ef4e9c9b152ea2f166c55768.svg";